<!-- eslint-disable -->
<template>
    <v-container class="home fill-height" fluid>
        <v-row justify="center" no-gutters>
            <v-col cols="12" sm="8" md="4" xl="2">
                <div class="py-12">
                    <v-img src="@/assets/logo.svg" class="w-100"/>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'SplashScreen',

        computed: {
            ...mapGetters({
                isAuthorized: 'auth/isAuthorized',
            }),
        },

        mounted() {
            this.bootstrap()
        },

        methods: {
            async bootstrap() {
                await new Promise(resolve => setTimeout(() => resolve(), 2000))

                // Restore access (from localStorage)
                await this.$store.dispatch('auth/restoreAccess')

                // Check access
                if (this.isAuthorized) {
                    this.toHome()
                } else if (this.$route.query.telnum !== undefined) {
                    this.toAuth()
                } else {
                    this.toPublic()
                }
            },

            toPublic() {
                if (!this.$route.matched.some(record => record.name === 'Public')) {
                    this.$router.push({ name: 'Public' })
                }
            },

            toHome() {
                if (!this.$route.matched.some(record => record.name === 'Home') && this.$route.params.nextRoute && this.$route.params.nextRoute.path !== '/') {
                    this.$router.push(this.$route.params.nextRoute)
                } else {
                    this.$router.push({ name: 'Home' })
                }
            },

            toAuth() {
                if (!this.$route.matched.some(record => record.name === 'Auth')) {
                    this.$router.push({ name: 'Auth', query: this.$route.query })
                }
            },
        },
    }
</script>
